export type PayerIdentityDraft = {
  firstName: string;
  lastName: string;
  email: string;
  addressLine1: string;
  addressLine2?: string;
  city: string;
  state: string;
  postalCode: string;
  dobMonth: string;
  dobDay: string;
  dobYear: string;
  ssnLast4: string;
};

export type PayerSetupResumeStep = 'identity' | 'payment_authorization' | 'confirm';

export type PayerSetupResumeState = {
  token: string;
  phone: string;
  nextStep: PayerSetupResumeStep;
  selectedPaymentBankId?: string | null;
  updatedAt: number;
};

const storageKey = (token: string) => `clero_payer_setup_resume_${String(token || '').trim()}`;

export const emptyPayerIdentityDraft = (): PayerIdentityDraft => ({
  firstName: '',
  lastName: '',
  email: '',
  addressLine1: '',
  addressLine2: '',
  city: '',
  state: '',
  postalCode: '',
  dobMonth: '',
  dobDay: '',
  dobYear: '',
  ssnLast4: '',
});

export const readPayerSetupResumeState = (token: string): PayerSetupResumeState | null => {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.sessionStorage.getItem(storageKey(token));
    if (!raw) return null;
    return JSON.parse(raw) as PayerSetupResumeState;
  } catch {
    return null;
  }
};

export const writePayerSetupResumeState = (state: PayerSetupResumeState) => {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(storageKey(state.token), JSON.stringify(state));
  } catch {
    // no-op
  }
};

export const clearPayerSetupResumeState = (token: string) => {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.removeItem(storageKey(token));
  } catch {
    // no-op
  }
};
